/* eslint-disable */

import React from 'react'
import { createScope, map, transformProxies } from './helpers'

const scripts = [

]

let Controller

class HelpComponentView extends React.Component {
  static get Controller() {
    if (Controller) return Controller

    try {
      Controller = require('../controllers/HelpComponentController')
      Controller = Controller.default || Controller

      return Controller
    }
    catch (e) {
      if (e.code == 'MODULE_NOT_FOUND') {
        Controller = HelpComponentView

        return Controller
      }

      throw e
    }
  }

  componentDidMount() {
    /* View has no WebFlow data attributes */

    scripts.concat(null).reduce((active, next) => Promise.resolve(active).then((active) => {
      const loading = active.loading.then((script) => {
        new Function(`
          with (this) {
            eval(arguments[0])
          }
        `).call(window, script)

        return next
      })

      return active.isAsync ? next : loading
    }))
  }

  render() {
    const proxies = HelpComponentView.Controller !== HelpComponentView ? transformProxies(this.props.children) : {
      'quote-button': [],
      'contact-button': [],
    }

    return (
      <span>
        <style dangerouslySetInnerHTML={{ __html: `
          @import url(/css/normalize.css);
          @import url(/css/webflow.css);
          @import url(/css/pss-testing.webflow.css);
        ` }} />
        <span className="af-view">
          <div className="af-class-section-21">
            <div className="af-class-container-30 w-container">
              <h1 className="af-class-heading-4">How can we help?</h1>
            </div>
            <div className="af-class-button-div">
              {map(proxies['quote-button'], props => <a href="#" {...{...props, className: `af-class-white-button w-button ${props.className || ''}`}}>{props.children ? props.children : <React.Fragment>Get a Quote</React.Fragment>}</a>)}
              {map(proxies['contact-button'], props => <a href="#" {...{...props, className: `af-class-blue-button w-button ${props.className || ''}`}}>{props.children ? props.children : <React.Fragment>Contact Us</React.Fragment>}</a>)}
            </div>
          </div>
        </span>
      </span>
    )
  }
}

export default HelpComponentView